import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="How to play" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Guess the filthy, weird or horrible nerd word in 6 tries. After each guess, the color of the tiles will
        change to show how close your guess was to the word. hurf blurf
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="C"
          status="correct"
        />
        <Cell value="O" />
        <Cell value="C" />
        <Cell value="K" />
        <Cell value="P" />
        <Cell value="I" />
        <Cell value="T" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter C is in the word and in the correct spot bluh
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="B" />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="U"
          status="present"
        />
        <Cell value="R" />
        <Cell value="R" />
        <Cell value="I" />
        <Cell value="T" />
        <Cell value="O" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter U is in the word but in the wrong spot huhhhh
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="C" />
        <Cell value="O" />
        <Cell value="O" />
        <Cell isRevealing={true} isCompleted={true} value="K" status="absent" />
        <Cell value="I" />
        <Cell value="E" />
        <Cell value="S" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter K is not in the word in any spot IDIOT
      </p>

      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
        Brought to you by <a className="underline font-bold" href="https://www.bonequest.com/">BoneQuest</a>{' '}
      </p>
    </BaseModal>
  )
}
